module.exports = __webpack_public_path__ + "img/profile2.a34314b4.png";